import styled from 'styled-components';
import { Common, color } from '@stockbit/ui';
import { ContentContainer } from 'global/NotesCompose/styled';

const { Modal: ModalAntd } = Common;

export const NotesItemContainer = styled.div`
  padding: 20px;
  border-bottom: solid 1px ${color.gainsboro};
`;

export const ImagePlaceholder = styled.span`
  background-color: #3A645C;
  border-radius: 70px;
  color: ${color.light};
  display: flex;
  margin: auto;
  min-height: 50px;
  min-width: 50px;

  > small {
    font-family: 'Proxima Nova', sans-serif;
    font-size: 20px;
    font-weight: 700;
    line-height: 27px;
    margin: auto;
    text-align: center;
  }
`;

export const ModalEditNoteWrapper = styled(ModalAntd)`
  .ant-modal-body {
    padding-top: 22px;
  }

  ${ContentContainer} {
    max-height: 70vh;
  }
`;

export const OptionItemContainer = styled.div`
  cursor: pointer;
  display: flex;
  margin-bottom: 16px;
`;
